import React, { useEffect, useState } from "react";
import requestsService from "../Services/requests";
import loadRazorpayScript from './loadRazorpayScipt';
import { useNavigate } from "react-router-dom";
import PropertiesService from "../Services/PropertiesService";
import loader from "../../src/assets/Images/Request_Property/Loader.gif";
import { toast, ToastContainer } from "react-toastify";
import "./Razorpay.css";

export const Product = ({
    amount,
    gstRate = 0,
    currency,
    paymentFor,
    userId,
    onPaymentStatusChange,
    paymentStatus,
    paymentRequestId,
    SuccessStatus,
    handlePropertyConvo,
    paymentMessage
}) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [status, setStatus] = useState("");
    const navigate = useNavigate();
    const baseAmount = Number(amount) || 0;
    const gstPercent = Number(gstRate) || 0;
    const payableAmount = baseAmount + ((baseAmount * gstPercent) / 100);

    const setRouteToProperty = () => {
        if (paymentMessage === 'KYP') {
            window.location.reload();
            navigate("/KYPList");
        } else {
            if (paymentRequestId) {
                localStorage.setItem("propertyDetails", JSON.stringify(paymentRequestId));
            }
            if (typeof handlePropertyConvo === "function") {
                handlePropertyConvo(paymentRequestId);
            }
            navigate("/reqProperty");
        }
    };

    const handleRazorpayPayment = async () => {
        setIsProcessing(true);
        setLoadingText("Loading Payment Gateway...");

        const isLoaded = await loadRazorpayScript();
        if (!isLoaded) {
            alert('Razorpay SDK failed to load.');
            setIsProcessing(false);
            return;
        }

        try {
            setLoadingText("Creating Secure Order...");
            let orderPayload = {
                amount: Math.round(payableAmount * 100),
                currency: currency,
                receipt: `rcpt_${Math.random().toString(36).substring(7)}`
            };

            const apiResponse = await requestsService.order(orderPayload);
            const findUserData = await PropertiesService.getdoCityUsers();
            const filterUser = findUserData?.data.find((x) => x.user_id === userId);

            const options = {
                key: 'rzp_test_ei92CLSMOT36xd', // Ensure this is your actual public key
                amount: apiResponse.amount,
                currency: apiResponse.currency,
                name: "DoCity",
                description: paymentMessage === 'KYP' ? "KYP Verification" : (paymentMessage === 'SOC' || paymentFor === 'SOC' ? "SOC Verification" : "Property Verification"),
                image: "https://your-logo-url.com/logo.png",
                order_id: apiResponse.id,
                handler: async (response) => {
                    setIsProcessing(true);
                    setLoadingText("Verifying Payment...");

                    const validationBody = {
                        razorpay_order_id: response?.razorpay_order_id,
                        razorpay_payment_id: response?.razorpay_payment_id,
                        razorpay_signature: response?.razorpay_signature,
                    };

                    const result = await requestsService.validatePayment(validationBody);

                    if (!result.success) {
                        setStatus("Error: Verification Failed");
                        setIsProcessing(false);
                        onPaymentStatusChange(false);
                    } else {
                        setLoadingText("Saving Transaction...");
                        let savePayload = {
                            ...validationBody,
                            amount: payableAmount,
                            userId: userId,
                            paymentFor: paymentFor,
                            paymentRequestId: paymentRequestId?._id || paymentRequestId || null
                        };

                        const saveResult = await requestsService.savePayments(savePayload);
                        const isSaveSuccess =
                            saveResult?.message === 'Success' ||
                            saveResult?.message?.toLowerCase?.() === 'success' ||
                            saveResult?.msg?.toLowerCase?.() === 'success' ||
                            saveResult?.success === true ||
                            saveResult?.status === 'success' ||
                            (saveResult && typeof saveResult === 'object' && !saveResult?.error && typeof saveResult !== 'string');
                        if (isSaveSuccess) {
                            setStatus("Success");
                            onPaymentStatusChange(true);
                            if (paymentFor === "requestForProperty" && SuccessStatus === "beforeRequest") {
                                setRouteToProperty();
                            }
                        } else {
                            console.error("savePayments response:", saveResult);
                            toast.error(saveResult?.error || saveResult?.message || "Data saving failed");
                            setIsProcessing(false);
                        }
                    }
                },
                prefill: {
                    name: filterUser?.name,
                    email: filterUser?.email,
                    contact: filterUser?.phoneNumber,
                },
                theme: { color: "var(--color-turquoise-teal)" },
                modal: {
                    ondismiss: function () {
                        setIsProcessing(false);
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("Payment Init Error", error);
            setIsProcessing(false);
        }
    };

    return (
        <div className="payment-container" >
            {/* SUCCESS STATE */}
            {paymentStatus === true ? (
                <div className="">
                    <div style={{ marginBottom: '20px' }}>
                        <div className="success-icon-wrap">✔️</div>
                    </div>
                    <h2 style={{ color: 'var(--color-turquoise-teal)', marginBottom: '10px' }}>
                        {paymentMessage === "KYP" ? "KYP" : "Property"} Payment Successful
                    </h2>
                    <p style={{ color: 'var(--color-oxford-blue)', marginBottom: '25px' }}>Your transaction has been verified and secured.</p>

                    {SuccessStatus === 'AfterRequest' ? (
                        <button className="proceed-btn-large" onClick={setRouteToProperty}>
                            {paymentMessage === "KYP" ? "Proceed To KYP" : "Proceed To Properties"}
                        </button>
                    ) : (
                        <button
                            className="proceed-btn-large"
                            onClick={() => {
                                paymentMessage === 'KYP' ? navigate('/KYPList') : setRouteToProperty();
                            }}
                        >
                            {paymentMessage === 'KYP' ? "View KYP Details" : "View Property Details"}
                        </button>
                    )}
                </div>
            ) : (
                /* INITIAL / PROCESSING STATE */
                <div className="">
                    {isProcessing ? (
                        <div className="loader-wrap">
                            <img src={loader} width={80} alt="Processing..." />
                            <h4 style={{ marginTop: '15px', color: 'var(--color-turquoise-teal)' }}>{loadingText}</h4>
                            <p style={{ fontSize: '12px', color: 'var(--color-turquoise-teal)' }}>Please do not refresh or close this window</p>
                        </div>
                    ) : (
                        <>
                            {status.includes('Error') && (
                                <div className="error-banner">
                                    ⚠️ Transaction Failed. Please check your network or try a different method.
                                </div>
                            )}

                            <div style={{ textAlign: 'left' }}>
                                <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '5px' }}>
                                    {paymentMessage} Service
                                </h2>
                                <p style={{ color: 'var(--color-oxford-blue)', fontSize: '14px', marginBottom: '20px' }}>
                                    Complete your payment to unlock professional insights.
                                </p>

                                <div className="benefit-box">
                                    <h4 style={{ fontSize: '14px', marginBottom: '10px' }}>Service Includes:</h4>
                                    <ul className="benefit-list">
                                        {paymentFor === 'knowYourProperty' ? (
                                            <>
                                                <li><span>✓</span> <strong>Ownership Certificate</strong></li>
                                                <li><span>✓</span> I hereby solemnly declare that all the information provided by me in respect of the property submitted is true, accurate, and complete to the best of my knowledge and belief.</li>

                                                <li><span>✓</span> <strong>Market Plan, Land Use Certificate</strong></li>
                                                <li><span>✓</span> I have applied with department / I will upload in 60 days for my property</li>

                                                <li><span>✓</span> I am interested in bank loan in near future / I already have a sanctioned loan on the property</li>

                                                <li><span>✓</span> <strong>Title Possession Protection</strong></li>
                                                <li><span>✓</span> In the future I give my consent to DoCity to share my property details with banks, insurance companies and government departments for safety of the property</li>
                                            </>
                                        ) : paymentFor === 'SOC' ? (
                                            <>
                                                <li><span>✓</span> <strong>Self Occupation Certificate Generation</strong></li>
                                                <li><span>✓</span> Official self occupation declaration & property verification</li>
                                                <li><span>✓</span> Verified documentation & certificate storage</li>
                                                <li><span>✓</span> Instant download access for verified property records</li>
                                            </>
                                        ) : (
                                            <>
                                                <li><span>✓</span> Clearance support for confident property buying</li>
                                                <li><span>✓</span> Master plan education focused on future city growth and development</li>
                                                <li><span>✓</span> Civil engineer guidance aligned with investment and property development</li>
                                                <li><span>✓</span> Bank loan support for added safety and security</li>
                                                <li><span>✓</span> Future access to insurance companies, government departments, and nationalized banks</li>
                                                <li><span>✓</span> Support toward title guarantee and property insurance readiness</li>
                                            </>
                                        )}
                                    </ul>
                                </div>

                                <button className="pay-btn-modern" onClick={handleRazorpayPayment}>
                                    Securely Pay ₹{payableAmount.toLocaleString()}
                                </button>
                                <p style={{ fontSize: '12px', color: 'var(--color-oxford-blue)', marginTop: '10px', textAlign: 'center', fontWeight: 600 }}>
                                    ⚠️ No refund after successful payment.
                                </p>
                                <p style={{ fontSize: '11px', color: 'var(--color-turquoise-teal)', marginTop: '15px', textAlign: 'center' }}>
                                    🔒 Encrypted SSL Secure Payment
                                </p>
                            </div>
                        </>
                    )}
                </div>
            )}
            <ToastContainer autoClose={2000} />
        </div>
    );
};
export default Product;

